import { render, staticRenderFns } from "./side-file.vue?vue&type=template&id=775385c1&scoped=true&"
import script from "./side-file.vue?vue&type=script&lang=js&"
export * from "./side-file.vue?vue&type=script&lang=js&"
import style0 from "./side-file.vue?vue&type=style&index=0&id=775385c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775385c1",
  null
  
)

export default component.exports